import { useEffect, useRef } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import toast from 'react-hot-toast'
import { authService } from '@/services/auth.service'
import { useAuthStore } from '@/store/authStore'

export function GoogleCallbackPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const processed = useRef(false)

  useEffect(() => {
    if (processed.current) return
    processed.current = true

    const code = searchParams.get('code')
    const error = searchParams.get('error')

    if (error) {
      toast.error('Google login cancelled')
      navigate('/login', { replace: true })
      return
    }

    if (!code) {
      toast.error('No authorization code received')
      navigate('/login', { replace: true })
      return
    }

    const redirectUri = `${window.location.origin}/auth/google/callback`
    const referralCode = localStorage.getItem('referral_code')

    authService
      .googleLogin(code, redirectUri, referralCode || undefined)
      .then(async (result) => {
        if (referralCode) {
          localStorage.removeItem('referral_code')
          localStorage.removeItem('referral_slug')
        }
        useAuthStore.getState().setUser(result.user)
        await useAuthStore.getState().fetchCurrentUser()
        toast.success('Logged in with Google')
        navigate(result.is_new_user ? '/onboarding' : '/pending-invitations', { replace: true })
      })
      .catch((err) => {
        toast.error(err.message || 'Google login failed')
        navigate('/login', { replace: true })
      })
  }, [searchParams, navigate])

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#FFFDF7' }}>
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-blue-500 mx-auto mb-4" />
        <p className="text-gray-600 font-medium">Signing in with Google...</p>
      </div>
    </div>
  )
}
